module.exports = __webpack_public_path__ + "img/badge_neuundexklusiv.7ea5cee.svg";